// import { EventEmitter, Injectable } from '@angular/core';
// import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
// import { ApiConfiguration } from './api-configuration';
// import { Observable as __Observable, throwError, from } from 'rxjs';
// import { map as __map, filter as __filter, catchError, retry } from 'rxjs/operators';
// import { AuthenticationCheckService } from '../auth/authentication-check.service';
// import { FormBuilder, FormGroup } from "@angular/forms";
// const httpOptions = {
//   headers: new HttpHeaders(
//     {
//       'Content-Type': 'application/json',
//       'X-Frame-Options': 'SAMEORIGIN'
//     }),
//   observe: 'response' as 'response'
// }

// @Injectable({
//   providedIn: 'root'
// })
// export class ApiService {

//   authToken;
//   program_id: any;
//   $beatResonseData = new EventEmitter();
//   $channelResonseData = new EventEmitter();
//   $addEngageData = new EventEmitter();
//   $target_frequencyData = new EventEmitter();

//   constructor(private httpClient: HttpClient, protected config: ApiConfiguration, private auth: AuthenticationCheckService) {
//     this.authToken = auth.getAuthToken();
//   }


//   // Get details from server
//   public get(url: any): __Observable<[]> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.get<any>(this.check_program_url(url), { responseType: 'json' })
//       .pipe(
//         catchError(this.handleError)
//       )
//   }

//   public getHeaders(url: any): __Observable<any> {
//     return this.httpClient.get<any>(this.check_program_url(url), { observe: 'response' });
//   }

//   public getFullResponse(url: any): __Observable<any> {
//     return this.httpClient.get<any>(this.check_program_url(url), { observe: 'response' }).pipe(catchError(this.handleError))
//   }

//   // post details to server
//   public post(url, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.post<any>(this.check_program_url(url, data), data, httpOptions).pipe(catchError(this.handleError))
//   }

//   // put details to server
//   public put(url, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.put<any>(this.check_program_url(url, data), data, httpOptions).pipe(catchError(this.handleError))
//   }

//   // put details to server
//   public delete(url, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.delete<any>(this.check_program_url(url, data), data).pipe(catchError(this.handleError))
//   }

//   public postFullResponse(url: any, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers, observe: 'response' }).pipe(catchError(this.handleError))
//   }

//   public postWithFormData(url, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'application/json' };
//     return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers, responseType: 'json' }).pipe(catchError(this.handleError))
//   }

//   public postWithFormDataNew(url, data: any): __Observable<any> {
//     let headers = { 'Content-Type': 'multipart/form-data' };
//     return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers }).pipe(catchError(this.handleError));
//     //return this.httpClient.post(url, data).map((response: Response) => { return response; }).catch(this.handleError);
//   }

//   // Post with Progress report
//   public upload(url, sendFile): __Observable<HttpEvent<any>> {
//     //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
//     return this.httpClient.post<any>(this.check_program_url(url, sendFile), sendFile, { reportProgress: true, observe: 'events' }).pipe(catchError(this.handleError))
//   }

//   public upload_with_loader(url, sendFile): __Observable<HttpEvent<any>> {
//     //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
//     return this.httpClient.post<any>(this.check_program_url(url, sendFile), sendFile, { reportProgress: true, observe: 'events' }).pipe(catchError(this.handleError))
//   }

//   /**
//    * 
//    * @param url, data
//    * @returns URL + program_id(dynamic)
//    */
//   check_program_url(url, data?) {
//     // get program id for LS
//     let programdetails: any;
//     programdetails = JSON.parse(window.localStorage.getItem("program"));
//     // If it is not the API that is used to change the program_id
//     if (url !== this.config.update_login_program && url !== this.config.login && url !== this.config.setupProgram && url !== this.config.create_update_program) {
//       // add program id if not exists
//       // replace program_id if already exists and is wrong, reason: some places have hardcoded values
//       try {
//         let check_q_mark = url.indexOf('?');
//         if (check_q_mark != -1) {
//           let last_char = url.charAt(url.length - 1);
//           let program = url.indexOf("program_id=1");
//           if (program != -1) {
//             url = url.replace("program_id=1", ("program_id=" + programdetails.program_id));
//           } else {
//             if (last_char != '/') {
//               url += "&program_id=" + programdetails.program_id;
//             }
//             // 
//           }
//         } else {
//           url += "?program_id=" + programdetails.program_id;
//         }
//       } catch (error) { }
//       // if it is a post request, meaning if it has a body
//       if (data) {
//         // if it is login API [inbuild method for Yii] 
//         //
//         //
//         if (url == this.config.login) {
          
//           data = JSON.parse(data)
//           data.LoginForm.program_id = programdetails.program_id
//         } else {
//           // every other post request
//           data.program_id = programdetails.program_id
//         }

//       }
//     }
//     return url;
//   }
//   // download file from server
//   // public downloadFile(url,data:any):__Observable<any>{
//   //   const headers = {
//   //     headers : new HttpHeaders({'Content-Type': 'application/json'})
//   //   }
//   //   return this.httpClient.get<any>(url,{responseType: 'json'}).pipe(catchError(this.handleError))
//   // }

//   // Error handling
//   private handleError(response: any) {
//     return throwError(response.error);
//   }
// }


// ---------------New File for security--------------------
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { ApiConfiguration } from './api-configuration';
import { Observable as __Observable, throwError, from } from 'rxjs';
import { map as __map, filter as __filter, catchError, retry } from 'rxjs/operators';
import { AuthenticationCheckService } from '../auth/authentication-check.service';
import { FormBuilder, FormGroup } from "@angular/forms";
import { XssSanitizerService } from 'src/app/shared/xss-sanitizer.service';
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
      'X-Frame-Options': 'SAMEORIGIN'
    }),
  observe: 'response' as 'response'
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  authToken;
  program_id: any;
  $beatResonseData = new EventEmitter();
  $channelResonseData = new EventEmitter();
  $addEngageData = new EventEmitter();
  $target_frequencyData = new EventEmitter();

  constructor(private httpClient: HttpClient, protected config: ApiConfiguration, private auth: AuthenticationCheckService, private sanitizer: XssSanitizerService) {
    this.authToken = auth.getAuthToken();
  }


  // Get details from server
  public get(url: any): __Observable<[]> {
    let headers = { 'Content-Type': 'application/json' };
    return this.httpClient.get<any>(this.check_program_url(url), { responseType: 'json' })
      .pipe(
        catchError(this.handleError)
      )
  }

  public getHeaders(url: any): __Observable<any> {
    return this.httpClient.get<any>(this.check_program_url(url), { observe: 'response' });
  }

  public getFullResponse(url: any): __Observable<any> {
    return this.httpClient.get<any>(this.check_program_url(url), { observe: 'response' }).pipe(catchError(this.handleError))
  }

  // post details to server
  // public post(url, data: any): __Observable<any> {
  //   let headers = { 'Content-Type': 'application/json' };
  //   const sanitizedData = this.sanitizer.sanitizeFormValues(data);
  //   if (sanitizedData.hasOwnProperty('image') && sanitizedData.image) {
  //     sanitizedData.image = this.sanitizer.sanitizeImageInput(sanitizedData.image);
  //   }
  //   return this.httpClient.post<any>(this.check_program_url(url, data), sanitizedData, httpOptions).pipe(catchError(this.handleError))
  // }

public post(url: string, data: any) {
  const sanitizeRecursively = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(item => sanitizeRecursively(item));
    }

    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    const result: any = {};

    Object.entries(obj).forEach(([key, value]) => {
      const lowerKey = key.toLowerCase();

      if (typeof value === 'string') {
        // Preserve empty strings
        if (value.trim() === '') {
          result[key] = '';
          return;
        }

        const isBase64Image = value.startsWith('data:image/');
        const containsHtmlTags = /<\/?[a-z][\s\S]*?>/i.test(value); // check if it's HTML

        if (lowerKey.includes('image') || isBase64Image) {
          result[key] = this.sanitizer.sanitizeImageInput(value);
        } else if (containsHtmlTags) {
          result[key] = this.sanitizer.sanitizeEditorPostInput(value) || '';
        } else {
          result[key] = this.sanitizer.sanitizeInput(value);
        }

      } else if (typeof value === 'object' && value !== null) {
        // Recursively sanitize nested objects or arrays
        result[key] = sanitizeRecursively(value);
      } else {
        // Numbers, booleans, etc.
        result[key] = value;
      }
    });

    return result;
  };

  const sanitizedData = sanitizeRecursively(data);

  return this.httpClient.post<any>(
    this.check_program_url(url, data),
    sanitizedData,
    httpOptions
  ).pipe(catchError(this.handleError));
}




//upload

//   this is for all validation

public upload(url: string, sendFile: FormData): __Observable<HttpEvent<any>> {
  const sanitizedFormData = new FormData();

  sendFile.forEach((value, key) => {
    const lowerKey = key.toLowerCase();

    if (typeof value === 'string') {
      // Always preserve empty fields
      if (value.trim() === '') {
        sanitizedFormData.append(key, '');
        return;
      }
      const isBase64Image = value.startsWith('data:image/');
      const containsHtml = /<\/?[a-z][\s\S]*?>/i.test(value);

     if (lowerKey.includes('image')) {
          // Sanitize image input (assumed implemented)
          sanitizedFormData.append(key, this.sanitizer.sanitizeImageInput(value));
       }else if (containsHtml) {
        // ✅ Sanitize HTML input (e.g., from Quill)
        const cleaned = this.sanitizer.sanitizeEditorInput(value);
        sanitizedFormData.append(key, cleaned);
      } else {
        // ✅ Plain text input
        const cleaned = this.sanitizer.sanitizeInput(value);
        sanitizedFormData.append(key, cleaned);
      }

    } else if (value instanceof File) {
      sanitizedFormData.append(key, value);
    } else {
      sanitizedFormData.append(key, value);
    }
  });

  return this.httpClient.post<any>(
    this.check_program_url(url),
    sanitizedFormData,
    {
      reportProgress: true,
      observe: 'events',
      headers: { skip: 'true' }
    }
  ).pipe(catchError(this.handleError));
}



  // put details to server
  public put(url, data: any): __Observable<any> {
    let headers = { 'Content-Type': 'application/json' };
    return this.httpClient.put<any>(this.check_program_url(url, data), data, httpOptions).pipe(catchError(this.handleError))
  }

  // put details to server
  public delete(url, data: any): __Observable<any> {
    let headers = { 'Content-Type': 'application/json' };
    return this.httpClient.delete<any>(this.check_program_url(url, data), data).pipe(catchError(this.handleError))
  }

  public postFullResponse(url: any, data: any): __Observable<any> {
    let headers = { 'Content-Type': 'application/json' };
    return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers, observe: 'response' }).pipe(catchError(this.handleError))
  }

  public postWithFormData(url, data: any): __Observable<any> {
    let headers = { 'Content-Type': 'application/json' };
    return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers, responseType: 'json' }).pipe(catchError(this.handleError))
  }

  public postWithFormDataNew(url, data: any): __Observable<any> {
    let headers = { 'Content-Type': 'multipart/form-data' };
    return this.httpClient.post<any>(this.check_program_url(url, data), data, { headers }).pipe(catchError(this.handleError));
    //return this.httpClient.post(url, data).map((response: Response) => { return response; }).catch(this.handleError);
  }

  // Post with Progress report


  // public upload(url, sendFile): __Observable<HttpEvent<any>> {
  //   //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
  //   return this.httpClient.post<any>(this.check_program_url(url, sendFile), sendFile, { reportProgress: true, observe: 'events', headers: { skip: "true" } }).pipe(catchError(this.handleError))
  // }

 


  // new upload method

  
  

  //  this method if key has empty value it will remove and send only the key in payload which has data

  // public upload(url: string, sendFile: FormData): __Observable<HttpEvent<any>> {
  //   const sanitizedFormData = new FormData();

  //   sendFile.forEach((value, key) => {
  //     const lowerKey = key.toLowerCase();

  //     if (typeof value === 'string') {
  //       if (lowerKey.includes('image')) {
  //         // Sanitize image input (assumed implemented)
  //         sanitizedFormData.append(key, this.sanitizer.sanitizeImageInput(value));
  //       } else {
  //         // Check if string contains HTML tags
  //         const containsHtml = /<\/?[a-z][\s\S]*?>/i.test(value);

  //         if (containsHtml) {
  //           // Rich HTML input - sanitize allowing safe tags
  //           const cleaned = this.sanitizer.sanitizeEditorInput(value);
  //           sanitizedFormData.append(key, cleaned);
  //         } else {
  //           console.log('here for inputs')
  //           // Plain input - sanitize and block dummy/malicious input inside sanitizeInput
  //           const cleaned = this.sanitizer.sanitizeInput(value);

  //           if (!cleaned) {
  //             // value is empty string, skip or append empty as needed
  //             console.warn(`Skipping key "${key}" because input was removed by sanitizer.`);
  //             return;  // skip adding this key to FormData
  //           }
  //           sanitizedFormData.append(key, cleaned);

  //         }
  //       }
  //     } else if (value instanceof File) {
  //       // For files, just append as is (or sanitize images if needed)
  //       sanitizedFormData.append(key, value);
  //     } else {
  //       // Other data types fallback (append as is)
  //       sanitizedFormData.append(key, value);
  //     }
  //   });

  //   return this.httpClient.post<any>(
  //     this.check_program_url(url),
  //     sanitizedFormData,
  //     {
  //       reportProgress: true,
  //       observe: 'events',
  //       headers: { skip: 'true' } // Let browser set content-type
  //     }
  //   ).pipe(catchError(this.handleError));
  // }


  //this method will only sanitize the data remaining payload it will send as it is

// public upload(url: string, sendFile: FormData): __Observable<HttpEvent<any>> {
//   const sanitizedFormData = new FormData();

//   sendFile.forEach((value, key) => {
//     const lowerKey = key.toLowerCase();

//     if (typeof value === 'string') {
//       let cleaned = value;

//       if (lowerKey.includes('image')) {
//         cleaned = this.sanitizer.sanitizeImageInput(value);
//       } else {
//         const containsHtml = /<\/?[a-z][\s\S]*?>/i.test(value);
//         cleaned = containsHtml
//           ? this.sanitizer.sanitizeEditorInput(value)
//           : this.sanitizer.sanitizeInput(value);
//       }

//       // ✅ Always append key, even if cleaned value is ''
//       sanitizedFormData.append(key, cleaned);

//     } else if (value instanceof File) {
//       sanitizedFormData.append(key, value);

//     } else {
//       sanitizedFormData.append(key, value);
//     }
//   });

//   return this.httpClient.post<any>(
//     this.check_program_url(url),
//     sanitizedFormData,
//     {
//       reportProgress: true,
//       observe: 'events',
//       headers: { skip: 'true' }
//     }
//   ).pipe(catchError(this.handleError));
// }
// only for input and editor
// public upload(url: string, sendFile: FormData): __Observable<HttpEvent<any>> {
//   const sanitizedFormData = new FormData();

//   sendFile.forEach((value, key) => {
//     const lowerKey = key.toLowerCase();

//     if (typeof value === 'string') {
//       // Always append the key, even if it's an empty string
//       if (value.trim() === '') {
//         sanitizedFormData.append(key, ''); // preserve empty values
//         return;
//       }

//       const containsHtml = /<\/?[a-z][\s\S]*?>/i.test(value);

//       if (containsHtml) {
//         // Sanitize HTML content (like from Quill)
//         const cleaned = this.sanitizer.sanitizeEditorInput(value);
//         sanitizedFormData.append(key, cleaned);
//       } else {
//         // Plain text input
//         const cleaned = this.sanitizer.sanitizeInput(value);
//         sanitizedFormData.append(key, cleaned);
//       }

//     } else if (value instanceof File) {
//       sanitizedFormData.append(key, value);
//     } else {
//       sanitizedFormData.append(key, value);
//     }
//   });

//   return this.httpClient.post<any>(
//     this.check_program_url(url),
//     sanitizedFormData,
//     {
//       reportProgress: true,
//       observe: 'events',
//       headers: { skip: 'true' } // browser sets content-type for FormData
//     }
//   ).pipe(catchError(this.handleError));
// }





  public upload_with_loader(url, sendFile): __Observable<HttpEvent<any>> {
    //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
    return this.httpClient.post<any>(this.check_program_url(url, sendFile), sendFile, { reportProgress: true, observe: 'events' }).pipe(catchError(this.handleError))
  }

  /**
   * 
   * @param url, data
   * @returns URL + program_id(dynamic)
   */
  check_program_url(url, data?) {
    // get program id for LS
    let programdetails: any;
    programdetails = JSON.parse(window.localStorage.getItem("program"));
    // If it is not the API that is used to change the program_id
    if (url !== this.config.update_login_program && url !== this.config.login && url !== this.config.setupProgram) {
      // add program id if not exists
      // replace program_id if already exists and is wrong, reason: some places have hardcoded values
      try {
        let check_q_mark = url.indexOf('?');
        if (check_q_mark != -1) {
          let last_char = url.charAt(url.length - 1);
          let program = url.indexOf("program_id=1");
          if (program != -1) {
            url = url.replace("program_id=1", ("program_id=" + programdetails.program_id));
          } else {
            if (last_char != '/') {
              url += "&program_id=" + programdetails.program_id;
            }
            // 
          }
        } else {
          url += "?program_id=" + programdetails.program_id;
        }
      } catch (error) { }
      // if it is a post request, meaning if it has a body
      if (data) {
        // if it is login API [inbuild method for Yii] 
        //
        //
        if (url == this.config.login) {

          data = JSON.parse(data)
          data.LoginForm.program_id = programdetails.program_id
        } else {
          // every other post request
          data.program_id = programdetails.program_id
        }

      }
    }
    return url;
  }
  // download file from server
  // public downloadFile(url,data:any):__Observable<any>{
  //   const headers = {
  //     headers : new HttpHeaders({'Content-Type': 'application/json'})
  //   }
  //   return this.httpClient.get<any>(url,{responseType: 'json'}).pipe(catchError(this.handleError))
  // }

  // Error handling
  private handleError(response: any) {
    return throwError(response.error);
  }
}
